import React from 'react'
import { Route, Switch } from "react-router-dom";
import Home from './Home';
import SensorDetailsContainer from '../SensorDetails/SensorDetailsContainer';



const HomeContainer = ({ match }) => {
    return (
        <Switch>
            <Route exact path={`${match.path}`} component={Home} />
            {<Route path={`${match.path}/:id/details`} component={SensorDetailsContainer} />}
        </Switch>
    )
}

export default HomeContainer